export const STORAGE_ATTEMPT_ID = "au_atid";
export const STORAGE_EXPIRE = "au_expd";
export const STORAGE_PHONE_NUMBER = "au_phnu";
